export const borderRadius = {
  'border-radius-none': 0,
  'border-radius-sm': 4,
  'border-radius-md': 8,
  'border-radius-lg': 12,
  'border-radius-xlg': 16,
  'border-radius-pill': 200,
  true: 4,
}

export const borderWidth = {
  'border-width-hairline': 1,
  'border-width-thin': 2,
  true: 1,
}
